import { Controller } from "@hotwired/stimulus"
import Choices from "choices.js"

export default class extends Controller {
  static targets = ["select"]

  connect() {
    this.choicesInstances = this.selectTargets.map((select) => new Choices(select, {
      searchEnabled: true,
      shouldSort: false,
      addChoices: true,
      renderChoiceLimit: -1,
      searchResultLimit: -1,
      fuseOptions: {
        threshold: 0.3,
        minMatchCharLength: 1
      }
    }))
  }

  disconnect() {
    this.choicesInstances.forEach((choices) => choices.destroy())
    this.choicesInstances = []
  }
}
